import { Injectable } from '@angular/core';
import { EpHttpService } from '../epHttpService/epHttp.service';
import { EpEnvironmentService } from '../epEnvironmentService/ep-environment.service';

@Injectable({
  providedIn: 'root'
})
export class EpQuotesService {
  constructor(private epHttpService: EpHttpService) { }

  getQuoteStatus(quoteid: number) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/quotes/${quoteid}/work-steps`;
    return this.epHttpService.request('GET', url);
  }

  getAllGroupQuotes(groupValue: number, businessType: string) {
    let url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/quotes`;
    if (businessType === 'PROSPECT') {
      url += `?groupId=${groupValue}&groupType=${businessType}`;
    } else {
      url += `?groupNumber=${groupValue}&groupType=RENEWAL`;
    }
    return this.epHttpService.request('GET', url);
  }

  getQuote(quoteid: number) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/${quoteid}`;
    return this.epHttpService.request('GET', url);
  }

  updateQuoteStatusId(body) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/updateQuoteStatusId`;
    return this.epHttpService.request('POST', url, { body });
  }
  createRenewalQuoteRequest(body) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/createRenewalQuote`;
    return this.epHttpService.request('POST', url, { body });
  }

  reTriggerTransactions(body) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/admin/re-trigger-transaction`;
    return this.epHttpService.request('POST', url, { body });
  }
}
